"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _StandardIconWrapper = _interopRequireDefault(require("./StandardIconWrapper"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var ResizeIcon =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(ResizeIcon, _React$PureComponent);

  function ResizeIcon() {
    _classCallCheck(this, ResizeIcon);

    return _possibleConstructorReturn(this, _getPrototypeOf(ResizeIcon).apply(this, arguments));
  }

  _createClass(ResizeIcon, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          color = _this$props.color,
          className = _this$props.className,
          props = _objectWithoutProperties(_this$props, ["color", "className"]);
      /* eslint-disable max-len */


      return _react.default.createElement(_StandardIconWrapper.default, _extends({
        className: (0, _classnames.default)(className, 'resize-icon')
      }, props), _react.default.createElement("path", {
        fill: color,
        d: "M11,7.00020832 C11.552,7.00020832 12,7.44818966 12,8.00016666 L12,8.00016666 L12,10.7500521 C12,11.4400233 11.44,12 10.75,12 L10.75,12 L8,12 C7.448,12 7,11.5520187 7,11.0000417 L7,11.0000417 L7.00673178,10.8832932 C7.06453061,10.3854907 7.48742857,10.0000833 8,10.0000833 L8,10.0000833 L9.749,10.0000833 C9.888,10.0000833 9.999,9.888088 9.999,9.75009375 L9.999,9.75009375 L9.999,8.00016666 C9.999,7.44818966 10.447,7.00020832 10.999,7.00020832 L10.999,7.00020832 Z M1,6.99970835 C1.553,6.99970835 2,7.44768968 2,7.99966668 L2,7.99966668 L2,9.74959377 C2,9.88758802 2.112,9.99958335 2.25,9.99958335 L2.25,9.99958335 L4,9.99958335 C4.553,9.99958335 5,10.4475647 5,10.9995417 L5,10.9995417 L4.99328243,11.1162901 C4.93560204,11.6140926 4.5135,11.9995 4,11.9995 L4,11.9995 L1.25,11.9995 C0.56,11.9995 0,11.4405233 0,10.7495521 L0,10.7495521 L0,7.99966668 C0,7.44768968 0.447,6.99970835 1,6.99970835 Z M4,0 C4.553,0 5,0.447981334 5,0.999958335 L5,0.999958335 L4.99328243,1.11670675 C4.93560204,1.61450926 4.5135,1.99991667 4,1.99991667 L4,1.99991667 L2.25,1.99991667 C2.112,1.99991667 2,2.111912 2,2.24990625 L2,2.24990625 L2,3.99983334 C2,4.5528103 1.553,4.99979168 1,4.99979168 C0.447,4.99979168 0,4.5528103 0,3.99983334 L0,3.99983334 L0,1.24994792 C0,0.559976668 0.56,0 1.25,0 L1.25,0 Z M10.75,0 C11.44,0 12,0.559976668 12,1.24994792 L12,1.24994792 L12,3.99983334 C12,4.5528103 11.552,4.99979168 11,4.99979168 L11,4.99979168 C10.447,4.99979168 9.999,4.5528103 9.999,3.99983334 L9.999,3.99983334 L9.999,2.24990625 C9.999,2.111912 9.888,1.99991667 9.749,1.99991667 L9.749,1.99991667 L8,1.99991667 C7.448,1.99991667 7,1.55293529 7,0.999958335 L7,0.999958335 L7.00673178,0.883394679 C7.06453061,0.38626962 7.48742857,0 8,0 L8,0 Z"
      }));
      /* eslint-enable max-len */
    }
  }]);

  return ResizeIcon;
}(_react.default.PureComponent);

exports.default = ResizeIcon;
ResizeIcon.defaultProps = {
  color: 'inherit'
};
ResizeIcon.propTypes = {
  className: _propTypes.default.string,
  color: _propTypes.default.string
};